'use strict';
'use es6';

/**
 * @param {string} color - A color in hex, rgb(), or rgba() format
 * @param {number} opacity - A number between 0 (transparent) and 1 (opaque)
 * @returns {string} A string of the form "rgba(255, 150, 51, 0.75)"
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rgba = rgba;
function rgba(color) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var r = void 0;
  var g = void 0;
  var b = void 0;

  color = color.toLowerCase();
  if (/^rgb/.test(color)) {
    var match = color.match(/(\d+)\D+(\d+)\D+(\d+)/);
    r = match[1];
    g = match[2];
    b = match[3];
  } else {
    color = color.replace(/^#/, '');
    if (color.length === 3) color = color.replace(/([0-9a-f])/g, '$1$1');
    r = parseInt(color.substring(0, 2), 16);
    g = parseInt(color.substring(2, 4), 16);
    b = parseInt(color.substring(4, 6), 16);
  }

  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity + ')';
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/core/Color.js
// module id = 110
// module chunks = 0